import styles from "../assets/styles/componenets/lessons.module.css";
import { useState, useEffect, useRef } from "react";
import badge from "../assets/images/badge.png";
import cart from "../assets/images/cart.svg";
import noco from "../assets/images/no-corruption.svg";
//import gov from "../assets/images/government-icon.svg";
import gov from "../assets/images/test.svg";
//government-icon.svg
//law-legal-icon.svg
import criminalLaw from "../assets/images/law-legal-icon.svg";
import lockhouse from "../assets/images/noun-confiscated-6037295.svg";
import cstm from "../assets/images/cstm.svg";

export default function Lessons() {
    const headerRef = useRef(null);
    const upperSectionRef = useRef(null);
    const certificationRef = useRef(null);

    const [isHeaderVisible, setHeaderVisible] = useState(false);
    const [isUpperSectionVisible, setUpperSectionVisible] = useState(false);

    const [isCertiVisible, setCertiVisible] = useState(false);

    const datePhrase = new Date().toLocaleDateString();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    if (entry.target === headerRef.current) {
                        setHeaderVisible(true);
                    } else if (entry.target === upperSectionRef.current) {
                        setUpperSectionVisible(true);
                    } else if (entry.target === certificationRef.current) {
                        setCertiVisible(true);
                    }
                }
            },
            { threshold: 0.05 }
        );

        const certifationObserver = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setCertiVisible(true);
                }
            },
            { threshold: 0.7 }
        );

        observer.observe(headerRef.current);
        observer.observe(upperSectionRef.current);
        certifationObserver.observe(certificationRef.current);
    }, []);

    return (
        <div id="lessons" className={styles.container}>
            <div
                className={`${styles.header} ${
                    isHeaderVisible && styles.visible
                }`}
                ref={headerRef}
            >
                <h2>
                    Իրավական գիտելիքների և գործնական հմտությունների ընդլայնում
                </h2>
                <p>
                    Մեր իրավաբանական դպրոցում մենք տրամադրում ենք խորացված
                    դասընթացներ, որոնք ուղղված են վերլուծական մտածողության,
                    իրավական վարպետության և բարոյական պրակտիկայի ձևավորմանը։ Մեր
                    ուսումնական ծրագիրը համադրում է տեսական գիտելիքներն ու
                    իրավակիրառությունը՝ ուսանողներին հաջողության նախապատրաստելու
                    համար։
                </p>
            </div>

            <div className={styles.lessonsContainer}>
                <div
                    className={`${styles.upperSection} ${
                        isUpperSectionVisible && styles.visible
                    }`}
                    ref={upperSectionRef}
                >
                    <div className={styles.lesson}>
                        <i className="fas fa-gavel"></i>
                        <h3>Դատավարական փաստաթղթերի կազմման հմտություններ</h3>
                    </div>

                    <div className={styles.lesson}>
                        <i className="fas fa-user-tie"></i>
                        <h3>Կորպորատիվ իրավունք</h3>
                    </div>
                    <div className={styles.lesson}>
                        <i className="fas fa-briefcase"></i>
                        <h3>Բիզնես իրավունք</h3>
                    </div>
                    <div className={styles.lesson}>
                        <img src={gov} alt="cart"></img>
                        <h3>Պետության իրավունքի տեսություն</h3>
                    </div>
                    <div className={styles.lesson}>
                        <img src={cart} alt="cart"></img>
                        <h3>
                            Գնումների մասին օրենսդրության վերլուծություն, գնման
                            ընթացակարգեր
                        </h3>
                    </div>
                    <div className={styles.lesson}>
                        <img src={noco} alt="no corruption"></img>
                        <h3>
                            Կոռուպցիոն հանցանքների առանձնահատկությունները՝ ըստ
                            գործող քրեական օրենսգրքի
                        </h3>
                    </div>
                    <div className={styles.lesson}>
                        <img src={criminalLaw} alt="criminal law"></img>

                        <h3>Քրեական իրավունք</h3>
                    </div>
                    <div className={styles.lesson}>
                        <i className="fas fa-file-contract"></i>
                        <h3>Քրեական դատավարություն</h3>
                    </div>
                    <div className={styles.lesson}>
                        <i className="fas fa-handshake"></i>
                        <h3>Քաղաքացիական իրավունք</h3>
                    </div>
                    <div className={styles.lesson}>
                        <i className="fas fa-clipboard"></i>
                        <h3>Քաղաքացիական դատավարություն</h3>
                    </div>
                    <div className={styles.lesson}>
                        <i className="fas fa-landmark"></i>
                        <h3>Վարչական իրավունք</h3>
                    </div>
                    <div className={styles.lesson}>
                        <i className="fas fa-folder-open"></i>
                        <h3>Վարչական դատավարություն</h3>
                    </div>
                    <div className={styles.lesson}>
                        <i className="fas fa-money-check-alt"></i>
                        <h3>Բանկային իրավունք</h3>
                    </div>
                    <div className={styles.lesson}>
                        <i className="fas fa-shield-alt"></i>
                        <h3>ապահովագրական իրավունք</h3>
                    </div>
                    <div className={styles.lesson}>
                    <i className="fas fa-house-lock"></i>
                        <h3>ապօրինի ծագում ունցող գույքի բռնագանձնման վարույթը և դրա հետևանքները</h3>
                    </div>
                    <div className={styles.lesson}>
                        <i className="fas fa-file-signature"></i>
                        <h3>Ֆիզիկական անձանց կողմից հայտարարագրերի ներկայացման առանձնահատկությունները</h3>
                    </div>
                    <div className={styles.lesson}>
                        <i className="fas fa-file-invoice-dollar"></i>
                        <h3>հարկային իրավունք</h3>
                    </div>
                    <div className={styles.lesson}>
                        <img src={cstm} alt="criminal law" style={{"scale": "1.7", "marginBottom": "10px"}}></img>
                        <h3>մաքսային իրավունք</h3>
                    </div>
                    <div className={styles.lesson}>
                        <i className="fas fa-users"></i>
                        <h3>Հաշտարարությունը և արբիտրաժը ՀՀ տարածքում</h3>
                    </div>
                </div>
                <div
                    ref={certificationRef}
                    className={`${styles.certificationContainer} ${
                        isCertiVisible && styles.visible
                    }`}
                >
                    <span></span>
                    <span></span>
                    <div className={styles.circle}></div>
                    <div className={styles.circle}></div>
                    <div className={styles.certificationContent}>
                        <div className={styles.certificationBadge}>
                            <i
                                className={`fas fa-graduation-cap ${styles.icon}`}
                            ></i>
                            <span className={styles.certificationText}>
                                Հավաստագիր
                            </span>
                        </div>
                        <div className={styles.certificationInfo}>
                            <p className={styles.description}>
                                Դասընթացի ավարտին ունկնդիրներին հանձնվում են
                                հավաստագրեր
                            </p>
                            <img src={badge} alt="certificationbadge"></img>
                            <div className={styles.yourName}>
                                Անուն Ազգանուն
                            </div>
                            <div className={styles.date}>{datePhrase}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
